export const PANEL_FILTERS = [
  { key: 'all', label: 'All regions' },
  { key: 'gauteng-north', label: 'Gauteng North' },
  { key: 'western-cape', label: 'Western Cape' },
  { key: 'claims-ops', label: 'Claims Ops' },
  { key: 'service-delivery', label: 'Service Delivery' },
  { key: 'available', label: 'Available' },
  { key: 'at-capacity', label: 'At capacity' }
];

export const ACTIVE_STATUS = {
  label: 'Available',
  color: '#2f7a5f',
  key: 'available'
};

export const INACTIVE_STATUS = {
  label: 'Inactive',
  color: '#bf8730',
  key: 'at-capacity'
};

export const AVATAR_COLORS = ['#0c5144', '#2e7b63', '#a77729', '#58318f', '#315e78', '#27589f'];
export const DEFAULT_SLA_BADGE_CLASS = 'bg-danger-subtle text-danger-emphasis border border-danger-subtle';
export const PANEL_MEMBER_ROLE_LABEL = 'Panel Member';
export const UNNAMED_PANEL_MEMBER = 'Unnamed Panel Member';
export const PANEL_MEMBER_FILTER_KEYS = ['availability_key', 'group_key', 'team_key', 'region_key'];
export const PANEL_MEMBER_NAME_OVERRIDES = new Map([[UNNAMED_PANEL_MEMBER, '']]);

export const SLA_BADGE_CLASSES = [
  { minimum: 90, class_name: 'bg-success-subtle text-success-emphasis border border-success-subtle' },
  { minimum: 80, class_name: 'bg-warning-subtle text-warning-emphasis border border-warning-subtle' }
];
